import React from "react"
import { Modal } from "@kohler-dsm-library/kohler-core"
import EmailFriendModalForm from "./EmailAFrndForm"
import styles from "./index.module.scss"

const EmailAFriend = ({
  emailAFrndModal = false,
  onClose = () => {},
  pdpData = {},
  locale = "en",
}) => {
  return (
    <Modal
      opened={emailAFrndModal}
      onClose={onClose}
      className={styles.modalContainer}
    >
      <EmailFriendModalForm onClose={onClose} pdpData={pdpData} locale={locale} />
    </Modal>
  )
}

export default EmailAFriend
